export const userSelectsDashboardMealPrep = () => ({
  type: 'Clicks meal prep',
});
